<template>
    <fragment>
        <li class="navigation-header"><span>{{ label }}</span></li>
        <slot></slot>
    </fragment>
</template>

<script>
export default {
    name: 'MenuSection',
    props: ['label'],
    data() {
        return {
            hasChildren: true,
        }
    },
    beforeUpdate() {
        this.hasChildren = this.checkForSlotContent();
    },
    created() {
        this.hasChildren = this.checkForSlotContent();
    },
    methods: {
        checkForSlotContent() {
            const checkForContent = (hasContent, node) => hasContent || node.tag || (node.text && node.text.trim());
            return this.$slots.default && this.$slots.default.reduce(checkForContent, false);
        },
    },
}
</script>
